import React from 'react'
import { Select } from 'antd'

const { Option } = Select

class SubjectSelect extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Select placeholder='please select subject' {...this.props} mode='multiple' allowClear showArrow style={{ width: '100%' }}>
        <Option value='nature'>Nature</Option>
        <Option value='landscape'>Landscape</Option>
        <Option value='animal'>Animal</Option>
        <Option value='fantasy'>Fantasy</Option>
        <Option value='portrait'>Portrait</Option>
        <Option value='urban'>Urban</Option>
        <Option value='geometric'>Geometric</Option>
        <Option value='figure'>Figure</Option>
        <Option value='others'>Others</Option>
      </Select>
    )
  }
}

export default SubjectSelect
